module.exports = __webpack_public_path__ + "img/female.4af63501.jpg";